import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginModule } from "./features/login/login.module";
import { AppInitService } from "src/app/core/services/app-init.service";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { ModalModule } from "ngx-bootstrap/modal";
import { OHEntityViewerHttpInterceptor } from "./core/services/msal/interceptors/mv-http.interceptor.service";
import { CoreModule } from "./core/core.module";
import { MatTableModule } from "@angular/material/table";
import { ApplicationInsightsService } from "./core/services/application-insights.service";
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from "@azure/msal-angular";
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
  MvMsalService,
} from "@aot/host-app-widgets-demo";
import { MvRouteGuardService } from "./core/services/msal/guards/mv-route-guard.service";

export function loadConfigurations(configService: AppInitService) {
  return () => configService.loadConfiguration();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LoginModule,
    HttpClientModule,
    CommonModule,
    ModalModule.forRoot(),
    CoreModule,

    MatTableModule,
  ],
  providers: [
    AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfigurations,
      deps: [AppInitService, HttpClient],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor, // <-- Apply MSAL interceptor first for token acquisition
      multi: true,
    },
      {
      provide: HTTP_INTERCEPTORS,
      useClass: OHEntityViewerHttpInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory, // <-- Configure MSAL instance for authentication
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory, // <-- Configure MSAL Guard
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory, // <-- Configure MSAL interceptor
    },
    MsalService,
    MsalGuard,
    MvRouteGuardService,
    MvMsalService,
    MsalBroadcastService,
    ApplicationInsightsService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
